import React from 'react';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';

function SocialIcons() {
    const elements = [
        {
            url: 'https://www.facebook.com/acessopopularbauru',
            icon: <FaFacebookF />,
            description: 'Facebook do Instituto Acesso Popular'
        }, 
        {
            url: 'https://www.instagram.com/acessopopular/',
            icon: <FaInstagram />,
            description: 'Instagram do Instituto Acesso Popular'
        }
    ];

    return (
        <div className='social-icons-list'>
            {elements.map((element) => (
                <a
                    key={element.url}
                    className='social-icon-link'
                    href={element.url}
                    target='_blank'
                    rel='noreferrer'
                    aria-label={element.description}
                >
                        {element.icon}
                </a>
            ))}
        </div>
    );
}

export default SocialIcons;
